import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PricingConfiguration = ({ planData, onUpdate, billingCycleOptions, accessLevelOptions }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="DollarSign" size={24} color="var(--color-accent)" />
        <h3 className="text-lg font-heading font-semibold text-foreground">Pricing Configuration</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Billing Cycle"
          options={billingCycleOptions}
          value={planData?.billingCycle}
          onChange={(value) => onUpdate('billingCycle', value)}
          required
        />
        <Input
          label="Price"
          type="number"
          placeholder="0.00"
          value={planData?.price}
          onChange={(e) => onUpdate('price', e?.target?.value)}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Setup Fee"
          type="number"
          placeholder="0.00"
          value={planData?.setupFee}
          onChange={(e) => onUpdate('setupFee', e?.target?.value)}
          description="One-time fee charged at signup"
        />
        <Input
          label="Trial Period (Days)"
          type="number"
          placeholder="0"
          value={planData?.trialPeriodDays}
          onChange={(e) => onUpdate('trialPeriodDays', e?.target?.value)}
          description="Number of free trial days"
        />
      </div>

      <div className="flex items-center gap-2 mb-4 pt-6 border-t border-border">
        <Icon name="Settings" size={24} color="var(--color-primary)" />
        <h3 className="text-lg font-heading font-semibold text-foreground">Access & Limits</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Access Level"
          options={accessLevelOptions}
          value={planData?.accessLevel}
          onChange={(value) => onUpdate('accessLevel', value)}
          required
        />
        <Input
          label="Max Members"
          type="number"
          placeholder="Unlimited"
          value={planData?.maxMembers}
          onChange={(e) => onUpdate('maxMembers', e?.target?.value)}
          description="Leave empty for unlimited"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Class Credits per Month"
          type="number"
          placeholder="0"
          value={planData?.classCredits}
          onChange={(e) => onUpdate('classCredits', e?.target?.value)}
          description="-1 for unlimited classes"
        />
        <Input
          label="Personal Training Sessions"
          type="number"
          placeholder="0"
          value={planData?.personalTrainingSessions}
          onChange={(e) => onUpdate('personalTrainingSessions', e?.target?.value)}
          description="Included sessions per month"
        />
      </div>

      <div className="flex items-center gap-2 mb-4 pt-6 border-t border-border">
        <Icon name="Eye" size={24} color="var(--color-success)" />
        <h3 className="text-lg font-heading font-semibold text-foreground">Display Settings</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Display Order"
          type="number"
          placeholder="0"
          value={planData?.displayOrder}
          onChange={(e) => onUpdate('displayOrder', e?.target?.value)}
          description="Lower numbers appear first"
        />
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="isActive"
              checked={planData?.isActive}
              onChange={(e) => onUpdate('isActive', e?.target?.checked)}
              className="w-4 h-4 rounded border-input bg-background text-primary focus:ring-2 focus:ring-ring"
            />
            <label htmlFor="isActive" className="text-sm font-medium text-foreground cursor-pointer">
              Active (visible to members)
            </label>
          </div>
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="isFeatured"
              checked={planData?.isFeatured}
              onChange={(e) => onUpdate('isFeatured', e?.target?.checked)}
              className="w-4 h-4 rounded border-input bg-background text-primary focus:ring-2 focus:ring-ring"
            />
            <label htmlFor="isFeatured" className="text-sm font-medium text-foreground cursor-pointer">
              Featured (highlighted as recommended)
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingConfiguration;